import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'

import type { ConfigState, GetterClass } from '../../../models'

export class InstancesGetter implements GetterClass {
  static execute(this: void, state: ConfigState): Instance[] {
    return state.instances
  }
}
